import type { LucideIcon } from 'lucide-react';
import styles from '../DashboardPage.module.css';

/** Generic loading / unavailable placeholder used by chart widgets
 *  that don't yet have real data, or while their query resolves. */
export default function ChartPlaceholder({
  title, icon: Icon, desc,
}: {
  title: string;
  icon: LucideIcon;
  desc: string;
}) {
  return (
    <div className={styles.chartBody}>
      <div className={styles.chartHeader}>
        <div className={styles.chartIcon}><Icon size={14} /></div>
        <p className={styles.chartTitle}>{title}</p>
      </div>
      <div className={styles.chartPlaceholder}>
        <p className={styles.chartDesc}>{desc}</p>
      </div>
    </div>
  );
}
